import React from 'react';
import PropTypes from 'prop-types';

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import {useTranslation} from 'react-i18next';

const PlanningManagement = ({withManagement, onManagementChange}) => {

  const {t} = useTranslation();

  return <RadioGroup value={withManagement ? 'with' : 'without'} row onChange={(e) => onManagementChange(e.target.value === 'with')}>
    <FormControlLabel value={'without'} control={<Radio/>} label={t('Sin Gestión')}/>
    <FormControlLabel value={'with'} control={<Radio/>} label={t('Añadir actuaciones')}/>
  </RadioGroup>;
};

PlanningManagement.propTypes = {
  withManagement: PropTypes.bool.isRequired,
  onManagementChange: PropTypes.func.isRequired,
};

export default PlanningManagement;